// promotionsApi.js: talks to the backend routes in backend/promotionsRoutes.js (mounted at /api/promotions).
// Every call sends the admin password in the "x-admin-password" header; the server checks it on every request.

// Same convention as HomePage.jsx: in production the API is on the same site (empty base), in development it is the
// local backend. REACT_APP_API_BASE overrides both.
const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === "production" ? "" : "http://localhost:5000");

const BASE = `${API_BASE}/api/promotions`;

async function request(method, path, password, body) {
  let res;
  try {
    res = await fetch(`${BASE}${path}`, {
      method,
      headers: {
        ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
        "x-admin-password": password,
      },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch (e) {
    throw new Error("Could not reach the server.");
  }

  let json = null;
  try {
    json = await res.json();
  } catch (e) {
    /* not JSON (for example an HTML error page from the proxy) */
  }

  if (res.status === 401) throw new Error("Wrong password");
  if (res.status === 429) throw new Error("Too many wrong passwords. Please try again in a few minutes.");
  if (res.status === 503) throw new Error((json && json.error) || "Promotions admin is not set up on the server yet.");
  if (!res.ok || !json || json.success === false) {
    throw new Error((json && json.error) || `Request failed (HTTP ${res.status}).`);
  }
  return json;
}

// The hotels you can manage: [{ slug, name, hotelId }]. Also serves as the password check when logging in.
export async function fetchHotels(password) {
  return (await request("GET", "/hotels", password)).data;
}

export async function fetchPromotions(slug, password) {
  return (await request("GET", `/hotels/${encodeURIComponent(slug)}`, password)).data;
}

export async function createPromotion(slug, password, fields) {
  return (await request("POST", `/hotels/${encodeURIComponent(slug)}`, password, fields)).data;
}

export async function updatePromotion(slug, password, id, fields) {
  return (await request("PUT", `/hotels/${encodeURIComponent(slug)}/${encodeURIComponent(id)}`, password, fields)).data;
}

export async function deletePromotion(slug, password, id) {
  await request("DELETE", `/hotels/${encodeURIComponent(slug)}/${encodeURIComponent(id)}`, password);
}
